import React from 'react';

import Tooltip from '../../tooltip/tooltip';
import Timer from '../timer/Timer';
import styles from '../../../../utils/styles';

import './timer-tooltip.scss';

export type ITimerStatus = 'start' | 'end' | 'progress' | 'resume' | null;

interface ITooltipTrigger extends React.ComponentPropsWithoutRef<'div'> {
  elapsed: string;
  status?: ITimerStatus;
  expandable: boolean;
}

const TooltipTrigger = React.forwardRef<HTMLDivElement, ITooltipTrigger>(function TooltipTrigger(props, ref) {
  const { elapsed, expandable } = props;
  // const expandable = status === 'progress';

  return (
    <div className={styles('c-timer-tooltip')} ref={ref}>
      <Timer elapsed={elapsed} expanded={false} expandable={expandable} />
    </div>
  );
});

const timerStatusTextMap = {
  start: 'Tieni d’occhio il timer per non perdere neanche un secondo di contenuti!',
  end: 'Tempo scaduto! Per ottenere altri 10 minuti, guarda nuovamente 2 annunci.',
};

export interface ITimerTooltip {
  elapsed: string;
  status: ITimerStatus;
}

const TimerTooltip: React.FC<ITimerTooltip> = ({ elapsed, status }) => {
  const tooltipContentMsg = status && timerStatusTextMap[status];

  console.log('[skylogger :: HlRoom] TimerTooltip elapsed = %s, status = %s', elapsed, status);
  const isOpen = Boolean(tooltipContentMsg);

  return (
    <Tooltip text={tooltipContentMsg} isOpen={Boolean(tooltipContentMsg)} position="left">
      <TooltipTrigger elapsed={elapsed} status={status} expandable={!isOpen} />
    </Tooltip>
  );
};

export default TimerTooltip;
